import { PagedRequest } from './paged-request';

export class UserExternalRequest extends PagedRequest {
  public searchText: string;
  public providerCollectionID: number;
  public userSuspenseId: number;
  public sortBy: string;
  public sortDir: boolean;
}
